export const UserFilterRole = [
    {name: "EXPERT", value: "EXPERT"},
    {name: "NORMAL", value: "NORMAL"},
    {name: "SUPER_ADMIN", value: "SUPER_ADMIN"},
    {name: "CRM", value: "CRM"},
];
